import { createFeatureSelector, createSelector } from "@ngrx/store";
import { FooterState } from "../../entites/footer-themes.model";





export const footer_state = createFeatureSelector<FooterState>('footer_theme');



export const FOOTER_CATEGORIES_SELECTOR = createSelector(
  footer_state, (state)=> {
    return state.footer_categories;
  }
);

export const STATIC_PAGES_SELECTOR = createSelector(
  footer_state, (state)=> {
    return state.static_pages;
  }
);

export const SOCIALS_SELECTOR = createSelector(
  footer_state, (state)=> {
    return state.socials;
  }
);

export const SITE_THEME_SELECTOR = createSelector(
  footer_state, (state)=> {
    return state.site_theme;
  }
);